var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctioLogoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_152",
    "data-name": "Group 152",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.5,
    height: 31.331,
    viewBox: "0 0 128.5 31.331",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 128.5,
    height: 31.33,
    fill: "#8dc3a7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_141",
    "data-name": "Group 141",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8092",
    "data-name": "Path 8092",
    d: "M14.329,30.2H0V6.8H14.329a8.3,8.3,0,0,1,0,16.6H6.9V9.706H2.907V27.293H14.329a12.193,12.193,0,1,0,0-24.386H9.8v1.9H6.9V0h7.431a15.1,15.1,0,0,1,0,30.2M9.8,20.494h4.525a5.394,5.394,0,0,0,0-10.789H9.8Z",
    transform: "translate(0 0)",
    fill: "#8dc3a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8093",
    "data-name": "Path 8093",
    d: "M32.91,27.65A10.892,10.892,0,0,1,30,19.742a10.684,10.684,0,0,1,3.047-7.925,10.393,10.393,0,0,1,7.636-3.029,10.394,10.394,0,0,1,7.637,3.029,10.658,10.658,0,0,1,3.047,7.906,10.419,10.419,0,0,1-3.181,7.908,10.855,10.855,0,0,1-7.772,3.027,9.984,9.984,0,0,1-7.5-3.008m7.5.115a7.105,7.105,0,0,0,5.149-2.14,7.926,7.926,0,0,0,2.179-5.92,8.063,8.063,0,0,0-2.083-5.9,6.842,6.842,0,0,0-5.072-2.121,6.6,6.6,0,0,0-5,2.121,8.277,8.277,0,0,0-2,5.92,8.481,8.481,0,0,0,1.928,5.92,6.329,6.329,0,0,0,4.9,2.122",
    transform: "translate(2.298 0.673)",
    fill: "#8dc3a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8094",
    "data-name": "Path 8094",
    d: "M55.493,27.649a11.039,11.039,0,0,1-2.854-7.926A11.039,11.039,0,0,1,55.493,11.8a9.747,9.747,0,0,1,7.4-3.009,10.252,10.252,0,0,1,6.229,1.774A9.318,9.318,0,0,1,72.5,15.616H68.721A5.534,5.534,0,0,0,66.6,12.723a6.346,6.346,0,0,0-3.7-1.042,6.1,6.1,0,0,0-4.839,2.1,8.756,8.756,0,0,0-1.832,5.94,8.752,8.752,0,0,0,1.832,5.94,6.1,6.1,0,0,0,4.839,2.1q4.512,0,5.823-3.934H72.5a9.608,9.608,0,0,1-3.414,4.976A9.982,9.982,0,0,1,62.9,30.657a9.746,9.746,0,0,1-7.4-3.008",
    transform: "translate(4.033 0.673)",
    fill: "#8dc3a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8095",
    "data-name": "Path 8095",
    d: "M82.036,27.8h2.893v2.854H81.381q-5.517,0-5.515-5.438V4.239h3.546V9.484H84.89v2.854H79.412V25.221a2.789,2.789,0,0,0,.579,2,2.855,2.855,0,0,0,2.044.579",
    transform: "translate(5.812 0.325)",
    fill: "#8dc3a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8096",
    "data-name": "Path 8096",
    d: "M94.244,5.6a2.308,2.308,0,0,1-1.7.693A2.24,2.24,0,0,1,90.87,5.6a2.343,2.343,0,0,1-.675-1.7,2.309,2.309,0,0,1,.694-1.7,2.376,2.376,0,0,1,3.355,0,2.309,2.309,0,0,1,.694,1.7,2.308,2.308,0,0,1-.694,1.7m-3.47,4.088h3.51V30.866h-3.51Z",
    transform: "translate(6.91 0.116)",
    fill: "#8dc3a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8097",
    "data-name": "Path 8097",
    d: "M102.42,27.65a10.9,10.9,0,0,1-2.912-7.908,10.684,10.684,0,0,1,3.047-7.925,11.145,11.145,0,0,1,15.275,0,10.658,10.658,0,0,1,3.047,7.906,10.422,10.422,0,0,1-3.181,7.908,10.855,10.855,0,0,1-7.772,3.027,9.985,9.985,0,0,1-7.5-3.008m7.5.115a7.1,7.1,0,0,0,5.148-2.14,7.922,7.922,0,0,0,2.18-5.92,8.064,8.064,0,0,0-2.084-5.9,6.839,6.839,0,0,0-5.072-2.121A6.6,6.6,0,0,0,105.1,13.8a8.277,8.277,0,0,0-2.006,5.92,8.486,8.486,0,0,0,1.928,5.92,6.332,6.332,0,0,0,4.9,2.122",
    transform: "translate(7.623 0.673)",
    fill: "#8dc3a7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctioLogoGreen);
export default __webpack_public_path__ + "static/media/doctio-logo-green.2e392630da78d0225811c5fa7bdc1de9.svg";
export { ForwardRef as ReactComponent };